import React, { useContext, useState } from 'react';
import {
	PermissionsContext,
	DATA_PERMISSIONS,
	APVENDORDB_PERMISSIONS,
} from 'contexts/PermissionsContext';
import { UploadStateContext } from 'contexts/UploadStateContext';
import { FileArchiveContextProvider } from 'contexts/FileArchiveContext/FileArchiveContextProvider';
import { Wrapper, Content, LoaderWrapper, InfoText } from './Data.styles';
import {
	useLocation,
	NavLink,
	Route,
	Redirect,
	Switch,
} from 'react-router-dom';
import { CONFIG } from './routes';
import {
	ApButtonSecondary,
	ApButtonTab,
	ApMenu,
	ApMenuItem,
	ApSecondaryNav,
	colors,
} from '@alixpartners/ui-components';
import OverwriteSpendCube from './OverwriteSpendCube';
import DownloadRawDataSection from './DownloadData';
import AppendData from './AppendData';
import VendorCleanup from './VendorCleanup';
import { VendorFileArchiveContextProvider } from 'contexts/VendorFileArchiveContext/VendorFileArchiveContextProvider';
import { VendorFileArchiveContext } from 'contexts/VendorFileArchiveContext';
import PushBenchmark from './BenchmarkDB/PushBenchmark';
import VendorEdit from './VendorEdit/VendorEdit';
import { UploadVendorStateContext } from 'contexts/UploadVendorStateContext';

import { ApSignalrConsumer } from '@alixpartners/ui-utils';
import { useHistory } from 'react-router-dom';

import PushToApVendorDB from './ApVendorDB/PushToApVendorDB';
import UpdateApVendorDB from './ApVendorDB/UpdateApVendorDB/UpdateApVendorDB';
import { ToastMessageProvider } from 'contexts/ToastMessageContext/ToastMessageProvider';
import { ClassificationThresholdProvider } from 'contexts/APVendorDBContext/ClassificationThresholdProvider';
import { NormalizationProvider } from 'contexts/NormalizationContext/NormalizationProvider';
import VendorMapping from './VendorMapping/VendorMapping';
import Form from 'Data/Form';
import GenerateSpendCube from './GenerateSpendCube/GenerateSpendCube';
import { GenerateSpendCubeContext } from 'contexts/GenerateSpendCubeContext';

import DownloadDeck from 'Data/DownloadDeck/DownloadDeck';
import { ActionItem } from 'Explore/TableView/styles';
import { CommonDialog } from 'SpendController/Components/CommonDialog';
import { ImportData } from './DownloadDeck/ImportData/ImportData';
import DownloadProgressbar from './DownloadData/DownloadProgressBar';
import { FetchDateRangesProvider } from 'contexts/DownloadDeckContext/DateRangeContext';
import { useFetchDataRangesContextProvider } from 'contexts/DownloadDeckContext/DateRangeContext';
const ContentComponent = {
	generateSpendCube: GenerateSpendCube,
	vendorCleanup: VendorCleanup,
	append: AppendData,
	vendorEdit: VendorEdit,
	upload: OverwriteSpendCube,
	download: DownloadRawDataSection,
	pushBenchmark: PushBenchmark,
	pushToApVendorDB: PushToApVendorDB,
	updateApVendorDB: UpdateApVendorDB,
	vendorMapping: VendorMapping,
	form: Form,
	downloadDeck: DownloadDeck,
};
const FIRST_UPLOAD_ROUTE = 'generateSpendCube';

export const Data = ({
	permissions,
	status,
	vendorStatus,
	refetchNormalization,
	normalizationUploadStatus,
}) => {
	const location = useLocation();
	const history = useHistory();
	const isFirstUpload = !status.isDataPublished;
	const hasSomePermissions = requiredSome => {
		return !requiredSome || requiredSome.some(i => permissions.includes(i));
	};
	const noPermissions = !hasSomePermissions(DATA_PERMISSIONS);
	const context = useContext(GenerateSpendCubeContext);
	const { currentState, isETL } = context;
		const shouldShowComponent = location.pathname === '/data/download-deck';
	const [isImportModalOpen, setIsImportModalOpen] = useState(false);
	const [showUploadSuccess, setShowUploadSuccess] = useState(false);
	const { setFetchDateRanges } = useFetchDataRangesContextProvider();

	const setValueInContext = newValue => {
		setFetchDateRanges(newValue);
	};

	const navDisabled = navName => {
		let isDisabled = false;
		if (
			(isFirstUpload && navName === 'pushtoDB') ||
			(isETL === 1 &&
				![1, 11, 9, 10].includes(currentState) &&
				navName === 'append') ||
			(isETL === 1 &&
				![1, 8, 9, 10, 11].includes(currentState) &&
				navName === 'vendorCleanup')
		) {
			isDisabled = true;
		} else {
			isDisabled = false;
		}
		return isDisabled;
	};

	const subNavDisabled = subNavName => {
		let isDisabled = false;
		if (
			(isETL === 1 &&
				subNavName === 'vendorCleanup' &&
				![1, 11, 8, 9].includes(currentState)) ||
			(isETL === 1 &&
				subNavName === 'vendorEdit' &&
				![1, 11, 9, 10].includes(currentState)) ||
			(isETL === 1 &&
				subNavName === 'vendorMapping' &&
				![1, 11].includes(currentState)) ||
			(isETL === 1 &&
				subNavName === 'append' &&
				![1, 11, 10].includes(currentState)) ||
			(isETL === 1 &&
				subNavName === 'upload' &&
				![1, 11].includes(currentState))
		) {
			isDisabled = true;
		} else {
			isDisabled = false;
		}
		return isDisabled;
	};

	// Fallback if none of the data permissions are granted
	if (noPermissions) {
		return (
			<Wrapper>
				<LoaderWrapper>
					<InfoText>You don't have permissions to view this page</InfoText>
				</LoaderWrapper>
			</Wrapper>
		);
	}
	const isSubNavDisable = name => {
		let flag = true;
		if (name === 'append') {
			flag = false;
		} else if (name === 'vendorEdit') {
			flag =
				vendorStatus.state === 1 && normalizationUploadStatus === 0
					? false
					: true;
		} else {
			flag = name !== FIRST_UPLOAD_ROUTE && isFirstUpload;
		}

		return flag;
	};
	return (
		<Wrapper>
			<ApSignalrConsumer
				message="VendorIntegration"
				onMessage={(
					messageName,
					statusMessage,
					currentUploadStep,
					totalUploadSteps
				) => {
					refetchNormalization();
					currentUploadStep === '1' && history.push('/data/vendor-cleanup');
				}}
			/>
			<ApSecondaryNav
				left={
					<React.Fragment>
						{CONFIG.map(tab => {
							if ('path' in tab) {
								const { label, path, name, requiredSome, routeEndsWith } = tab;
								if (requiredSome && !hasSomePermissions(requiredSome)) {
									return null;
								}
								return (
									<NavLink to={path} key={path}>
										<ApButtonTab
											// isSelected={location.pathname.includes(path)}
											isSelected={location.pathname
												.split('/')
												.includes(routeEndsWith)}
											disabled={isSubNavDisable(name)}
										>
											{label}
										</ApButtonTab>
									</NavLink>
								);
							} else {
								if (tab.requiredSome && !hasSomePermissions(tab.requiredSome)) {
									return null;
								}
								return (
									<ApMenu
										key={tab.label}
										toggleVariant="hover"
										button={
											<ApButtonTab
												toggleVariant="hover"
												isSelected={tab.child.some(
													child =>
														child.path === location.pathname ||
														location.pathname.includes(child.path)
												)}
											>
												{tab.label}
											</ApButtonTab>
										}
										disabled={navDisabled(tab.name)}
									>
										{tab.child.map(
											({ label, path, name, requiredSome, routeEndsWith }) => {
												if (requiredSome && !hasSomePermissions(requiredSome)) {
													return null;
												}
												return (
													<ApMenuItem
														key={label}
														style={{
															backgroundColor:
																path === location.pathname ||
																location.pathname.includes(path)
																	? colors.green0
																	: null,
														}}
														disabled={subNavDisabled(name)}
												>
														<NavLink to={path} key={path}>
															{label}
														</NavLink>
													</ApMenuItem>
												);
											}
										)}
									</ApMenu>
								);
							}
						})}
					</React.Fragment>
				}
				right={
					<React.Fragment>
						{shouldShowComponent && (
							<ActionItem>
								<ApButtonSecondary
									onClick={() => {
										setIsImportModalOpen(true);
									}}
									iconName="upload_outlined"
								>
									Import Data
								</ApButtonSecondary>
							</ActionItem>
						)}
					</React.Fragment>
				}
			/>

			<Content>
				<Switch>
					{CONFIG.flatMap(({ child }) => child).map(
						({ path, name, requiredSome }) => {
							if (!hasSomePermissions(requiredSome)) {
								return null;
							}

							return (
								<Route
									key={path}
									path={path}
									component={ContentComponent[name]}
								/>
							);
						}
					)}

					<Redirect
						to={
							!isFirstUpload
								? (() => {
										for (const { child } of CONFIG) {
											for (const { path, requiredSome } of child) {
												if (hasSomePermissions(requiredSome)) {
													return path;
												}
											}
										}
										return CONFIG[0].child[0].path;
								  })()
								: CONFIG[0].child[0].path
						}
					/>
				</Switch>
				{isImportModalOpen && (
					<CommonDialog
						onClose={() => setIsImportModalOpen(false)}
						body={
							<ImportData
								successClose={() => {
									setIsImportModalOpen(false);
								}}
								onUploadSuccess={() => {
									setShowUploadSuccess(true);
									setValueInContext('imported');
									setTimeout(() => {
										setShowUploadSuccess(false);
									}, 1500);
								}}
							/>
						}
						title="Import data"
						maxWidth={640}
						suppressFooter
					/>
				)}
			</Content>
			{showUploadSuccess && (
				<DownloadProgressbar
					successMessage="Data uploaded successfully..."
					onClose={() => setShowUploadSuccess(false)}
				/>
			)}
		</Wrapper>
	);
};

export default props => (
	<FetchDateRangesProvider>
		<FileArchiveContextProvider>
			<VendorFileArchiveContextProvider>
				<NormalizationProvider>
					<VendorFileArchiveContext.Consumer>
						{({ fileArchive, state }) => (
							<UploadVendorStateContext.Consumer>
								{({ vendorStatus }) => (
									<UploadStateContext.Consumer>
										{({ status, normalizationUploadStatus, refetch }) => (
											<PermissionsContext.Consumer>
												{({ permissions }) => (
													<ToastMessageProvider>
														{permissions.some(permission =>
															APVENDORDB_PERMISSIONS.includes(permission)
														) ? (
															<ClassificationThresholdProvider>
																<Data
																	{...props}
																	permissions={permissions || []}
																	status={status}
																	normalizationUploadStatus={
																		normalizationUploadStatus
																	}
																	state={state}
																	vendorStatus={vendorStatus}
																	fileArchive={fileArchive}
																	refetchNormalization={refetch}
																/>
															</ClassificationThresholdProvider>
														) : (
															<Data
																{...props}
																permissions={permissions || []}
																status={status}
																normalizationUploadStatus={
																	normalizationUploadStatus
																}
																state={state}
																vendorStatus={vendorStatus}
																fileArchive={fileArchive}
																refetchNormalization={refetch}
															/>
														)}
													</ToastMessageProvider>
												)}
											</PermissionsContext.Consumer>
										)}
									</UploadStateContext.Consumer>
								)}
							</UploadVendorStateContext.Consumer>
						)}
					</VendorFileArchiveContext.Consumer>
				</NormalizationProvider>
			</VendorFileArchiveContextProvider>
		</FileArchiveContextProvider>
	</FetchDateRangesProvider>
);
